// extracted by mini-css-extract-plugin
export var label = "_ct-5";
export var slideContainer = "_ct-0";
export var slider = "_ct-1";
export var sliderLg = "_ct-4";
export var sliderMd = "_ct-3";
export var sliderSm = "_ct-2";